// extracted by mini-css-extract-plugin
export var active = "_cu-7";
export var blink = "_cu-8";
export var dropDownSelector = "_cu-4";
export var dropDownWrapper = "_cu-3";
export var fakeCursor = "_cu-6";
export var fontSizeButton = "_cu-9";
export var formQuillEditor = "_cu-0";
export var pressed = "_cu-a";
export var qlBlank = "_cu-1";
export var textFormattingToolbar = "_cu-2";
export var textToolbarOption = "_cu-5";